(function() {
    'use strict';

    angular
        .module('spidwebApp')
        .component('pixlMedia', {
            bindings: {
                media: '=',
                mediaClick: '&',
                mediaRemove: '&',
                removable: '=',
                language: '='
            },
            templateUrl: 'common/directives/pixl/pixl-media.html',
            controller: PixlMediaController
        });

    PixlMediaController.$inject = ['wediaService', '$http'];

    function PixlMediaController(wediaService, $http) {
        const FALLBACK_IMAGE = 'common/styles/img/deleted.png';

        this.$onInit = () => {
            this.mediaURL = wediaService.getMediaURL(this.media, 50);
            this.willExpireSoon = wediaService.willExpireInMonths(this.media, 6);
            this.hasExpired = wediaService.hasExpired(this.media);

            $http.head(this.mediaURL)
                .then(response => {
                if (response.status === 410) {
                    console.warn(`Media not found (Error 410) : ${this.media.pixlId}`);
                    this.mediaURL = FALLBACK_IMAGE;
                }
            })
                .catch(error => {
                    console.error(`Error while retrieving the media ${this.media.pixlId}, status: ${error.status}`);
                    this.mediaURL = FALLBACK_IMAGE;
                });
        };
    }

})();
